module.exports = __webpack_public_path__ + "static/img/zengzhishuifapiao@3xffc1271.png";